import { Outlet, useLocation } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import classNames from 'classnames'

import ErrorComponent from '../components/ErrorComponent/ErrorComponent'
import Image from '../components/ui/Image/Image'
import TabButton from '../components/ui/TabButton/TabButton'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import useGetFetchedData from '../hooks/useGetFetchedData'

import { mediaParamList } from '../Contansts'
import MediaLeft from '../assets/images/MediaLeft.svg'
import MediaRight from '../assets/images/MediaRight.svg'

import styles from './pages.module.scss'
import { useLanguage } from '../context/LangaugeContextProvider/LangaugeContextProvider'
import { isLanguage } from '../utils'

function Media() {
  const { pathname } = useLocation()
  const { language } = useLanguage()
  const { isFrench } = isLanguage(language?.code)

  const { data, loading, error } = useGetFetchedData(mediaParamList)

  const tabs = data?.result?.tabs
  const breadcrumbs = data?.result?.breadcrumbs
  const pageTitle = data?.result?.pagetitle

  const pageData = {
    sectiondata: data?.result?.sectiondata,
    pagination: data?.pagination,
    emptyMessage: data?.result?.emptymessage,
  }

  return (
    <div className="media-container">
      <Image src={MediaLeft} alt="media left" className="media-left-image" />
      <Image src={MediaRight} alt="media right" className="media-right-image" />

      {loading ? (
        <div className="flex justify-center mt-8">
          <Spinner />
        </div>
      ) : error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <>
          <div className="page-container">
            <div className="page-header text-center page-title-padding">
              {pageTitle}
            </div>
            <div className="tabs-container tabs-margin">
              {tabs?.map((tab, index) => {
                return (
                  <TabButton
                    key={index}
                    label={tab?.link?.label}
                    path={tab?.link?.path}
                    type="link"
                    tabIsActive={
                      tab?.link?.path &&
                      tab?.link?.path.includes('knowledge-center') &&
                      pathname.includes('knowledge-center')
                    }
                    buttonClassname={classNames(
                      styles.mediaTabWidth,
                      isFrench ? styles.mediaTabFont : ''
                    )}
                  />
                )
              })}
            </div>
            <Outlet context={pageData} />
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </>
      )}
    </div>
  )
}

export default Media
